// FR
export const propAuthLocksHc = {
  autoridades: {
    breadcrumbCurrent: `Autorités compétentes`,
    selectorLabel: `Sélectionnez l'autorité de police de votre région`,

    // Fragments de statut partagés
    msgConnected: `Connecté.`,
    msgValidated: `Validé.`,
    msgValidationError: `Erreur de validation.`,

    // SES Hospedajes
    sesSubtitle: `Secrétariat d'État à la Sécurité – Ministère de l'Intérieur`,
    sesConnectedText: `Les check-in seront envoyés automatiquement à SES Hospedajes.`,
    sesVerifyCreds: `Vérifiez les identifiants saisis.`,
    sesNotConnected: `Vous n'avez pas encore connecté de compte SES Hospedajes.`,
    updateConnectedAccount: `Mettre à jour le compte connecté`,

    // Ertzaintza A19
    ertzSubtitle: `Police autonome du Pays basque – Registre des voyageurs`,
    ertzConnectedText: `Les check-in seront envoyés automatiquement à l'Ertzaintza.`,
    ertzVerifyCif: `Vérifiez le CIF et le code de l'établissement.`,
    ertzCredsSaved: `Identifiants enregistrés. Cliquez sur "Vérifier la connexion" pour contrôler l'accès.`,
    ertzCifLabel: `CIF de l'établissement`,
    ertzCifPlaceholder: `Ex. B12345678`,
    ertzCifHint: `Max. 10 caractères. CIF du bailleur enregistré auprès de l'Ertzaintza.`,
    ertzCodeLabel: `Code de l'établissement`,
    ertzCodePlaceholder: `Ex. 01000001`,
    ertzCodeHint: `Attribué par l'Ertzaintza lors de l'enregistrement de l'établissement.`,
    envLabel: `Environnement`,
    envPre: `Pré-production (tests)`,
    envPro: `Production`,
    envHint: `Utilisez "Pré-production" pour valider avant d'activer en production.`,
    verifying: `Vérification...`,
    verifyConnection: `Vérifier la connexion`,
    saving: `Enregistrement...`,
    updateCredentials: `Mettre à jour les identifiants`,
    saveAndConnect: `Enregistrer et connecter`,

    // Mossos d'Esquadra
    mossosSubtitle: `Generalitat de Catalunya – Registre de viatgers d'establiments d'hostalatge`,

    // SIRE
    sireSubtitle: `Système d'information d'enregistrement des étrangers – Migración Colombia`,
    sireConnectedText: `Les check-in seront envoyés automatiquement.`,
    sireRevisaCreds: `Vérifiez les identifiants.`,
    docTypeLabel: `Type de document`,
    selectTypePlaceholder: `Sélectionnez le type`,
    docNumberLabel: `Numéro de document`,
    docNumberPlaceholder: `Ex. 123456789`,
    passwordLabel: `Mot de passe`,
    sirePasswordPlaceholder: `Mot de passe SIRE`,
    showHideTitle: `Afficher/masquer`,
    saveChanges: `Enregistrer les modifications`,

    // TRA
    traSubtitle: `Ministère du Commerce, de l'Industrie et du Tourisme – Jeton d'autorisation`,
    traReportsText: `Rapports automatiques activés.`,
    traRevisaToken: `Vérifiez le jeton/RNT.`,
    traTokenLabel: `Jeton d'autorisation`,
    traTokenPlaceholder: `Collez ici le jeton émis par le TRA`,
    traCurrentToken: `Jeton actuel : {token}`,
    traNoTokenHint: `Si vous n'avez pas encore de jeton PMS, vous pouvez le générer sur`,
    traRntLabel: `RNT de l'établissement`,
    traRntPlaceholder: `Chiffres uniquement (ex. 123456)`,
    traRntHint: `Il doit s'agir du RNT actif de l'établissement (5 à 15 chiffres).`,

    // Types de document (Colombie)
    docTypeCitizenId: `Carte d'identité de citoyen`,
    docTypeForeignerId: `Carte d'identité d'étranger`,

    // Alloggiati Web (placeholder résiduel)
    alloggiatiIdPlaceholder: `Ex. 1234`,

    // Notifications / messages du script
    needSaveListing: `Vous devez d'abord enregistrer l'annonce.`,
    authChangedErtz: `Autorité changée pour Ertzaintza (Pays basque).`,
    authChangedMossos: `Autorité changée pour Mossos d'Esquadra (Catalogne).`,
    authChangedSes: `Autorité changée pour SES Hospedajes.`,
    authChangeError: `Impossible de changer l'autorité.`,
    ertzSaved: `Identifiants Ertzaintza enregistrés.`,
    saveGenericError: `Erreur lors de l'enregistrement.`,
    ertzSaveError: `Erreur lors de l'enregistrement des identifiants Ertzaintza.`,
    ertzTestOk: `Connexion avec l'Ertzaintza vérifiée avec succès.`,
    testFailedCheck: `La vérification a échoué. Vérifiez les données.`,
    ertzTestError: `Erreur lors de la vérification de la connexion avec l'Ertzaintza.`,
    mossosNeedCreds: `Saisissez l'identifiant et le mot de passe du site des Mossos.`,
    mossosFound: `{count} établissement trouvé. Choisissez le vôtre. | {count} établissements trouvés. Choisissez le vôtre.`,
    mossosNoEstablishments: `Aucun établissement trouvé sur ce compte.`,
    mossosConnError: `Impossible de se connecter aux Mossos. Vérifiez l'identifiant et le mot de passe.`,
    mossosNeedFields: `Renseignez l'identifiant policier et le code de l'établissement.`,
    mossosSaved: `Identifiants Mossos enregistrés.`,
    mossosSaveError: `Erreur lors de l'enregistrement des identifiants Mossos.`,
    mossosTestOk: `Connexion avec les Mossos vérifiée avec succès.`,
    mossosTestError: `Erreur lors de la vérification de la connexion avec les Mossos.`,
    mossosFileOk: `Fichier généré. Téléversez-le sur le site des Mossos (Fitxers massius).`,
    mossosNoTravelers: `Aucun voyageur en attente d'envoi.`,
    mossosConfigFirst: `Configurez d'abord l'établissement.`,
    mossosFileError: `Impossible de générer le fichier.`,
    sireCompleteData: `Complétez les données requises pour SIRE.`,
    sireSaved: `SIRE enregistré avec succès.`,
    sireSaveFailed: `Impossible d'enregistrer SIRE.`,
    sireSaveError: `Erreur lors de l'enregistrement de SIRE.`,
    sireDeactivated: `SIRE désactivé.`,
    sireActivated: `SIRE activé.`,
    sireStateFailed: `Impossible de changer l'état de SIRE.`,
    sireStateError: `Erreur lors du changement d'état de SIRE.`,
    traNeedToken: `Saisissez le jeton et un RNT valide (chiffres uniquement).`,
    traSaved: `TRA enregistré avec succès.`,
    traSaveFailed: `Impossible d'enregistrer TRA.`,
    traSaveError: `Erreur lors de l'enregistrement de TRA.`,
    traDeactivated: `TRA désactivé.`,
    traActivated: `TRA activé.`,
    traStateFailed: `Impossible de changer l'état de TRA.`,
    traStateError: `Erreur lors du changement d'état de TRA.`,
    stateChangeFailed: `Impossible de changer l'état.`,
    alloggiatiStateError: `Erreur lors du changement d'état d'Alloggiati Web.`,
    ross1000StateError: `Erreur lors du changement d'état de ROSS 1000.`,
  },

  smartLocks: {
    loadingConfig: `Chargement de la configuration…`,
    accessKeyTypeLabel: `Type de clé d'accès`,
    selectLockPlaceholder: `Sélectionnez la serrure`,
    optionStatic: `Clé statique`,
    optionTtlock: `TTLock - Serrure dynamique`,
    optionTedee: `Tedee - Serrure dynamique`,
    optionShelly: `Shelly - Relais intelligent`,
    optionYacan: `YACAN - Serrure intelligente`,
    optionAkiles: `Akiles - Serrure intelligente`,
    optionOther: `Une autre marque qui n'apparaît pas ici…`,
    pillTedee: `Accès dynamique (Tedee)`,
    pillTtlock: `Accès dynamique (TTLock)`,
    pillShelly: `Ouverture à distance (Shelly)`,
    pillYacan: `Accès géré (YACAN)`,
    pillAkiles: `Akiles connecté`,
    pillStatic: `Accès statique`,
    pillOther: `Écrivez-nous et nous vous aiderons à l'intégrer`,
    disconnecting: `Déconnexion…`,
    disconnect: `Déconnecter`,
    emptyTitle: `Connectez votre serrure intelligente`,
    emptyText: `Choisissez votre marque dans le menu déroulant ci-dessus pour la connecter et générer automatiquement une nouvelle clé à chaque réservation.`,
    emptyBrandOther: `Autres marques`,
    unitFallback: `Unité {id}`,
    staticModeInfo: `Mode statique sélectionné. Saisissez une clé et cliquez sur Enregistrer pour l'appliquer.`,
    saveTypeError: `Impossible d'enregistrer le type d'accès`,
    disconnectSuccess: `Serrure déconnectée`,
    disconnectError: `Impossible de déconnecter la serrure.`,
  },

  rates: {
    pageTitle: `Tarifs`,
    loading: `Chargement des tarifs…`,
    roomsCount: `{count} chambre | {count} chambres`,
    singleUnit: `Unité unique`,
    newBtn: `Nouveau`,
    colName: `Nom`,
    colAdjustment: `Ajustement`,
    colFinal: `Prix final`,
    labelMain: `Principal`,
    labelDerived: `Dérivé`,
    base: `Base`,
    editTitle: `Modifier`,
    copyTitle: `Copier vers une autre unité`,
    deleteTitle: `Supprimer`,
    noDerived: `Il n'y a pas de tarifs dérivés pour ce rate plan.`,
    emptyTitle: `Aucun tarif principal`,
    emptyText: `Créez un tarif principal pour cette unité, puis vous pourrez créer des tarifs dérivés.`,
    emptyCreate: `Créer le premier tarif principal`,
    globalEmptyTitle: `Aucune unité chargée`,
    globalEmptyText: `Créez d'abord des chambres/unités pour pouvoir gérer les tarifs.`,
    editRate: `Modifier le tarif`,
    newRate: `Nouveau tarif`,
    fieldName: `Nom`,
    namePlaceholder: `Ex. : Tarif flexible`,
    validityPeriod: `Période de validité`,
    validityPermanent: `Permanent`,
    validityCustom: `Personnalisé`,
    validityHintCustom: `Facultatif : s'applique uniquement dans la plage`,
    validityHintPermanent: `Tarif toujours valide`,
    startLabel: `Début`,
    endLabel: `Fin`,
    pricePerNight: `Prix par nuit`,
    taxIncluded: `Taxes incluses`,
    occupancy: `Occupation`,
    guestsNumber: `Nombre de voyageurs`,
    minStay: `Séjour minimum`,
    maxStay: `Séjour maximum`,
    description: `Description`,
    optional: `Facultatif`,
    rateplanBase: `Rate Plan de base`,
    selectRateplanBase: `Sélectionnez un rate plan de base`,
    rateplanBaseHint: `Sélectionnez le rate plan sur lequel ce tarif dérivé sera calculé.`,
    derivedNamePlaceholder: `Ex. : Booking.com, Airbnb…`,
    derivedNameHint: `Ce nom vous aide à identifier le tarif lors du mappage des OTA.`,
    adjustmentType: `Type d'ajustement`,
    percentage: `Pourcentage`,
    fixedAmount: `Montant fixe`,
    adjustmentValue: `Valeur de l'ajustement`,
    adjustmentValueHint: `(négatif pour une remise)`,
    preview: `Aperçu`,
    basePrice: `Prix de base`,
    increment: `Augmentation`,
    discount: `Remise`,
    cancel: `Annuler`,
    saving: `Enregistrement...`,
    update: `Mettre à jour`,
    create: `Créer`,
    deleteModalTitle: `Supprimer le tarif`,
    deleteWarnStrong: `Cette action est irréversible.`,
    deleteWarnLead: `Vous allez supprimer :`,
    deleteCascadeLabel: `Supprimer aussi ses tarifs dérivés ({count})`,
    deleteCascadeHint: `Si un tarif dérivé est lié à une OTA, la suppression sera bloquée.`,
    deleteConfirmLabel: `Saisissez le nom exact pour confirmer :`,
    deleteConfirmPlaceholder: `Saisissez exactement le nom`,
    deleteConfirmHint: `Cela évite les suppressions accidentelles.`,
    deleting: `Suppression...`,
    deleteConfirmBtn: `Supprimer définitivement`,
    copyModalTitle: `Copier le tarif vers une autre unité`,
    copyOrigin: `Origine :`,
    copyRate: `Tarif :`,
    copyTargetUnit: `Unité de destination`,
    selectUnit: `Sélectionnez une unité`,
    copySameUnitHint: `Vous ne pouvez pas copier vers la même unité.`,
    copyTargetBaseRate: `Tarif de base de destination`,
    selectMainRate: `Sélectionnez un tarif principal`,
    copyDerivedHint: `Ce tarif dérivé sera lié à ce tarif principal dans l'unité de destination.`,
    copyNoMainRates: `L'unité de destination n'a pas de tarifs principaux. Créez ou copiez d'abord un tarif principal.`,
    copyNewNameLabel: `Nom à destination`,
    copyRenameHint: `Vous pouvez le renommer pour éviter les doublons.`,
    copyCascadeLabel: `Copier aussi les tarifs dérivés ({count})`,
    copyCascadeHint: `De nouveaux tarifs dérivés seront créés en pointant vers le rate plan principal copié.`,
    copying: `Copie...`,
    copyBtn: `Copier`,

    // Notifications / messages du script
    loadError: `Erreur lors du chargement des tarifs`,
    rangeErrorSelect: `Vous devez sélectionner une plage de dates valide`,
    rangeErrorStartEnd: `La date de début ne peut pas être postérieure à la date de fin`,
    rangeErrorMinStay: `Le séjour minimum est de {minStay} nuits, mais la plage sélectionnée comporte {nights} nuits`,
    invalidUnit: `Unité invalide`,
    completeRequired: `Remplissez les champs obligatoires`,
    updated: `Mis à jour`,
    created: `Créé`,
    saveError: `Erreur lors de l'enregistrement`,
    deleted: `Supprimé`,
    deleteLinkedOta: `Suppression impossible : lié à une OTA.`,
    deleteGenericError: `Erreur lors de la suppression`,
    deleteDerivedError: `Impossible de supprimer le tarif dérivé`,
    copied: `Copié`,
    copyGenericError: `Erreur lors de la copie`,
    invalidTargetUnit: `Unité de destination invalide`,
    selectTargetBaseError: `Sélectionnez le tarif de base de destination pour lier le tarif dérivé.`,
    invalidTargetBaseError: `Le tarif de base de destination sélectionné n'est pas valide pour l'unité de destination.`,
    defaultRateName: `Tarif`,
    defaultDerivedName: `Dérivé`,
    copySuffix: `(Copie)`,
  },
};
